// axiosInterceptor.js
import axios from 'axios';

axios.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401) {
            // Only redirect if not already on a login page to prevent loops
            const currentPath = window.location.pathname;
            const isLoginPage =
                currentPath === '/' ||
                currentPath === '/phone-login' ||
                currentPath.startsWith('/phone-login/');
            if (!isLoginPage) {
                // Global session expiration handling
                window.location.href = '/';
            }
        }
        return Promise.reject(error);
    }
);
